import { configsResult, configsPageResult } from '../../models/advConfig/zod.js';
import { clientGet, clientPost, clientPut } from '../../utils/fetchwrapper.js';
import { processBody } from '../../utils/fetchwrapperUtils/responseProcessors.js';

const getConfigs = (origin, params) => clientGet({
    url: `${origin}/v1/private/adv/configs`,
    queryParams: params,
}).then(processBody(null, configsResult));
const getConfigPage = (origin, params) => clientGet({
    url: `${origin}/v1/adv/configs/page`,
    queryParams: params,
}).then(processBody(null, configsPageResult));
const updateConfig = (origin, config) => clientPost({
    url: `${origin}/v1/adv/configs/page`,
}, config).then(processBody(null, configsPageResult));
const activateConfig = (origin, id) => clientPut({
    url: `${origin}/v1/adv/configs/page`,
}, { id }).then(processBody(null, configsPageResult));

export { activateConfig, getConfigPage, getConfigs, updateConfig };
//# sourceMappingURL=client.js.map
